import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("rk-lang") || "de");

  useEffect(() => {
    localStorage.setItem("rk-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => dict[lang]?.[key] ?? dict.en[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang outside provider");
  return ctx;
}
